import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../components/provider/AppContext";
import styles from "./ColorSelector.module.css";
import ImageRenderer from "../../components/imageProvider/ImageRenderer";
import { useSwipeable } from "react-swipeable";
import { useNavigate } from "react-router-dom";
import { plannerStore } from "../../App";
import PlannerDisplayer from "../../components/plannerDisplay/PlannerDisplayer";

const ColorSelector = () => {
  const templateTypes = {
    Basic: ["Basic 1", "Basic 2"],
    Bullet: ["Bullet 2", "Bullet 3", "Bullet 4"],
    Calendar: ["Calendar 1", "Calendar 2"],
    Graph: ["Graph 1"],
    Journal: ["Journal 1", "Journal 2", "Journal 3"],
    Lined: ["Lined 1"],
    List: ["List 1", "List 2"],
    Schedule: ["Schedule 1", "Schedule 2", "Schedule 3"],
    StayOnTask: ["Stay On Task 1"],
  };
  const navigate = useNavigate();
  const updatePlannerType = plannerStore((state) => state.updatePlannerType);
  const updateCalendarType = plannerStore((state) => state.calendar);
  const updatedTemplateSelected = plannerStore(
    (state) => state.updateTemplateSelected
  );
  const [plannerType, setPlannerType] = useState("No Planner");
  const types = templateTypes[plannerType] || [];
  const [planner, setPlanner] = useState("");

  const passContext = (key, value) => {
    setAppData({ ...appData, [key]: value });
    localStorage.setItem("appData", JSON.stringify(appData));
  };
  const { appData, setAppData } = useContext(AppContext);

  useEffect(() => {
    const updatedData = {
      ...appData,
      nextPageText: "Color",
      backPageText: "",
      nextPageLink: "template",
      backPageLink: "colorSelection",
      currentPage: 0,
    };

    setAppData(updatedData);
  }, []);

  useEffect(() => {
    if (appData?.templateType) {
      setPlanner(appData.templateType);
    }
    if (appData?.plannerType) {
      setPlannerType(appData.plannerType);
    }
  }, [appData]);

  const handlers = useSwipeable({
    onSwipedLeft: () => navigate("/template"),
  });
  return (
    <>
      <div
        className={`container-fluid d-flex flex-column justify-content-center align-items-center ${styles["fade-in"]}`}
        style={{
          height: "80vh",
          paddingTop: "0px",
          width: "auto",
          marginTop: "5rem",
        }}
        {...handlers}
      >
        <div
          className={`container-fluid d-flex flex-column justify-content-center ${styles["displayer"]} align-items-center`}
        >
          <div className={styles["image"]}>
            <ImageRenderer
              photoTypeSelected={plannerType}
              photoSelected={planner}
            />
          </div>
        </div>
        <form>
          <div className="form-group">
            <label htmlFor="selectPlannerType">Planner Type: </label>
            <select
              onChange={({ target }) => {
                setPlannerType(target.value);
                passContext("plannerType", target.value);
                updatePlannerType(target.value);
              }}
              className="form-control"
              id="selectPlannerType"
              value={plannerType}
            >
              <option value={"No Template"} selected hidden disabled>
                Please Select a Template
              </option>
              {Object.keys(templateTypes).map((plannerType) => {
                return (
                  <option key={plannerType} value={plannerType}>
                    {plannerType}
                  </option>
                );
              })}
            </select>
            <br></br>
            <label htmlFor="selectPlanner">Available Types:</label>
            {plannerType ? (
              <select
                onChange={({ target }) => {
                  updatedTemplateSelected(target.value);
                  setPlanner(target.value);
                  passContext("templateType", target.value);
                }}
                className="form-control"
                id="selectPlanner"
                value={planner}
              >
                <option value={"No Template"} selected hidden>
                  Please Select a Template
                </option>
                {types.map((planner) => {
                  return (
                    <option key={planner} value={planner}>
                      {planner}
                    </option>
                  );
                })}
              </select>
            ) : (
              <li>No types available</li>
            )}
          </div>
        </form>
      </div>
    </>
  );
};
export default ColorSelector;
